import { render } from "./ConfirmationPopUp.vue?vue&type=template&id=2fc97830&scoped=true"
import script from "./ConfirmationPopUp.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopUp.vue?vue&type=script&lang=js"

import "./ConfirmationPopUp.vue?vue&type=style&index=0&id=2fc97830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc97830"]])

export default __exports__